import i18next from 'i18next';
import { _URL_FORM, abrirFormCadastro, fecharFormCadastro } from './helpers';
import { janelaAjuda } from './janelaAjuda';
import { progressoCurriculo } from './progresso';

// declarado p/ strict mode (era global implicito)
var html;

export const diversidade = function () {
    const $divPanel = '#panel-diversidade';
    const $panel = body.find($divPanel);

    const _listar = function () {
        window.global.loaderPanel.show($divPanel);
        $.ajax({
            type: "GET",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/GetDiversidade', cache: false,
            success: function (data) {
                html = "";

                const elementNull = document.getElementById("diversidade-null");

                if (!data.DadosNulos) {

                    let compartilarDados = true;

                    if (data.NaoInformarDadosDiversidade)
                        compartilarDados = false;

                    if (data.DadosNulos)
                        compartilarDados = false;

                    elementNull.className = 'hide';

                    html = `
                    <div class="row">
                    <div class="col-md-6 mb10 ${data.Pronome == 3 ? 'hide' : ''}">
                        <h4><b>${i18next.t('diversidadePronome')}</b></h4>
                        <p class="pronome-preview" data-pronome="${data.Pronome}">${data.PronomeTexto}</h4>
                    </div>
                    <div class="col-md-6 mb10 ${data.IdentidadeGenero == 3 ? 'hide' : ''}">
                        <h4><b>${i18next.t('diversidadeIdentidadeGenero')}</b></h4>
                        <p class="identidade-genero-preview" data-identidade-genero="${data.IdentidadeGenero}">${data.IdentidadeGeneroTexto}</h4>
                    </div>
                    <div class="col-md-6 mb10 ${data.OrientacaoSexual == 6 ? 'hide' : ''}">
                        <h4><b>${i18next.t('diversidadeOrientacaoSexual')}</b></h4>
                        <p class="orientacao-sexual-preview" data-orientacao-sexual="${data.OrientacaoSexual}">${data.OrientacaoSexualTexto}</p>
                    </div>
                    <div class="col-md-6 mb10 ${data.RacaCor == 6 ? 'hide' : ''}">
                        <h4><b>${i18next.t('diversidadeRacaCor')}</b></h4>
                        <p class="raca-cor-preview" data-raca-cor="${data.RacaCor}">${data.RacaCorTexto}</p>
                    </div>
                    <div class="compartilhar-dados-preview hide" data-compartilhar-dados="${compartilarDados}"></div>
                </div>
                    `;
                    document.getElementById('diversidade-lista').innerHTML = html;
                    $panel.find('.btn-editar').on('click', function () {
                        _abrir();
                    });

                    $panel.find('.btn-add').removeClass('hide');

                    const badgesNaoInformar = document.querySelectorAll('.label-nao-informar-diversidade');
                    // Todos forem não informar
                    if (data.NaoInformarDadosDiversidade) {
                        $panel.find('.panel-body').addClass('hide');
                        badgesNaoInformar.forEach((badgeNaoInformar) => badgeNaoInformar.classList.remove('hide'));
                        window.global.loaderPanel.hide($divPanel);
                        return;
                    }
                    else
                        badgesNaoInformar.forEach((badgeNaoInformar) => badgeNaoInformar.classList.add('hide'));
                }
                else {
                    elementNull.className = '';
                }
                window.global.loaderPanel.hide($divPanel);
            },
            error: function () {
                window.global.loaderPanel.hide($divPanel);
            }
        });
    };
    const _salvar = function () {
        var content = body.find('#form-diversidade');

        const pronome = content.find('#container-pronome').find('input[name="Pronome"]:checked').val();
        const identidadeGenero = content.find('#container-identidade-genero').find('input[name="IdentidadeGenero"]:checked').val();
        const orientacaoSexual = content.find('#container-orientacao-sexual').find('input[name="OrientacaoSexual"]:checked').val();
        const racaCor = content.find('#container-raca-cor').find('input[name="RacaCor"]:checked').val();
        const compartilharDados = content.find('#compartilhar-dados').is(':checked');

        window.global.loaderButton.show(content.find('button[type=submit]'));

        $.ajax({
            type: "POST",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/SaveDiversidade', cache: false,
            data: {
                Pronome: pronome,
                IdentidadeGenero: identidadeGenero,
                OrientacaoSexual: orientacaoSexual,
                RacaCor: racaCor,
                CompartilharDadosDiversidade: compartilharDados,
            },
            success: function (data) {
                if (data.success == 1) {
                    toastr.success(i18next.t('diversidadeSalvoSucesso'), '', { "closeButton": true });

                    _listar();
                    progressoCurriculo();
                    _fechar();
                }
                else {
                    swal("", data.error, "error");
                    window.global.loaderButton.hide(content.find('button[type=submit]'));
                }

            },
            error: function () {
                window.global.loaderButton.hide(content.find('button[type=submit]'));
                swal("", i18next.t('erroServidor'), "error");
            }
        });
    };

    const _fechar = function () {
        document.getElementById('diversidade-contentform').innerHTML = '';


        goToByScroll($divPanel);
        fecharFormCadastro();
    };
    const _abrir = function () {
        goToByScroll($divPanel);
        window.global.loaderPanel.show($divPanel);
        $panel.find('.panel-body').removeClass('hide');

        const formulario = body.find('#diversidade-contentform');
        const dados = $panel.find('#diversidade-lista');
        abrirFormCadastro();
        formulario.load(_URL_FORM + "Diversidade?v=2", function () {
            $.validate({
                form: '#form-diversidade'
            });
            const containersRadio = document.querySelectorAll('.container-radio');

            containersRadio.forEach(containersRadio => {
                const radios = containersRadio.querySelectorAll('.radio');
                radios.forEach(radio => {
                    const input = radio.querySelector('input');

                    input.addEventListener('change', () => {
                        radios.forEach(radio3 => radio3.classList.remove('radio-checked'));

                        if (input.checked)
                            radio.classList.add('radio-checked');
                    });
                });
            });

            const preencherRadioButtons = (propName) => {
                const container = document.querySelector(`#container-${propName}`);
                if (!container)
                    return;
                const containerRadios = container.querySelectorAll('.radio');

                containerRadios.forEach(radio => {
                    const input = radio.querySelector('input');
                    radio.classList.remove('radio-checked');

                    if (input.value == dados.find(`.${propName}-preview`).attr(`data-${propName}`) || (radio.classList.contains('nao-informar') && input.checked == true)) {
                        input.checked = true;
                        radio.classList.add('radio-checked');
                    }
                });
            };

            preencherRadioButtons('pronome');
            preencherRadioButtons('identidade-genero');
            preencherRadioButtons('orientacao-sexual');
            preencherRadioButtons('raca-cor');


            const valorDataAtributo = dados.find('.compartilhar-dados-preview').attr('data-compartilhar-dados');
            // Converte a string "true" ou "false" para um valor booleano
            let isChecked = valorDataAtributo === "true";
            // Define o estado 'checked' do checkbox baseado no valor booleano
            formulario.find('#compartilhar-dados').prop('checked', isChecked);


            formulario.find('.close-panel').on('click', function (e) {
                _fechar();

                const panelDiversidade = document.querySelector('#panel-diversidade');
                if (!panelDiversidade.querySelector('.label-nao-informar-diversidade').classList.contains('hide'))
                    panelDiversidade.querySelector('.panel-body').classList.add('hide');

                e.preventDefault();
            });

            formulario.find('#form-diversidade').on('submit', function (e) {
                if ($(this).isValid()) {
                    _salvar();
                }
                e.preventDefault();
            });

            janelaAjuda(formulario);
            window.global.loaderPanel.hide($divPanel);

            $(function () {
                $('[data-toggle="tooltip"]').tooltip()
            })
        });
    };
    const _naoInformar = function () {
        const btn = body.find('#panel-diversidade').find('.btn-nao-possui');
        const badgeNaoInformar = document.querySelector('.label-nao-informar-diversidade');
        window.global.loaderButton.show(btn);
        $.ajax({
            type: "POST",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/SaveDiversidade', cache: false,
            data: {
                Pronome: 3, // Nao informar codigo
                IdentidadeGenero: 3, // Nao informar codigo
                OrientacaoSexual: 6, // Nao informar codigo
                RacaCor: 6, // Nao informar codigo
                CompartilharDadosDiversidade: false, // Nao informar codigo
                NaoInformarDadosDiversidade: true, // Todos dados nao informar
            },
            success: function (data) {
                if (data.success == 1) {
                    toastr.success(i18next.t('diversidadeSalvoSucesso'), '', { "closeButton": true });
                    _listar();
                    badgeNaoInformar.classList.remove('hide');
                    progressoCurriculo();
                }
                else {
                    swal("", data.error, "error");
                }
                window.global.loaderButton.hide(btn);
            },
            error: function () {
                window.global.loaderButton.hide(btn);
                swal("", i18next.t('erroServidor'), "error");
            }
        });
    };

    const init = function () {
        _listar();
        $panel.find('.btn-add').on('click', function (e) {
            _abrir();
            e.preventDefault();
        });

        $panel.find('.btn-nao-possui').on('click', function (e) {
            _naoInformar();
            e.preventDefault();
        });
    }

    return init();
};
